<template>
  <el-dialog
    :title="popTitle"
    :visible.sync="visibleDialog"
    width="630px"
    top="calc(50vh - 350px)"
    class="pop-dialog pop-result-list"
    append-to-body>
    <div class="result-con" v-loading="loading">
      <el-table
        :data="tableData">
        <el-table-column
          type="index"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="销售订单号"
          width="150">
        </el-table-column>
        <el-table-column
          v-if="type == 'tag'"
          label="操作结果">
          <template slot-scope="scope">
            <template v-if="scope.row.tagOperationDetails && scope.row.tagOperationDetails.length>0">
              <div v-for="(item,index) in scope.row.tagOperationDetails" :key="index" class="line">
                {{ item.operationType?'开启:':'关闭:' }}
                <template v-if="item.tagType==1">
                  <span :class="'tag-no tag-'+item.tagId"></span>
                </template>
                <template v-else>{{ item.tagName }}</template>
                {{ item.failureReason?'（失败 '+item.failureReason+'）':'（成功）' }}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="type == 'publicAudit' || type == 'privateAudit'"
          label="操作结果">
          <template slot-scope="scope">
            {{ scope.row.auditResultDesc || '成功' }}
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="type == 'setOrderDate'"
          label="操作结果">
          <template slot-scope="scope">
            {{ scope.row.failureReason?'失败 '+scope.row.failureReason:'成功' }}
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="type == 'setLogistics'"
          label="操作结果">
          <template slot-scope="scope">
             {{ scope.row.failureReason?'失败 '+scope.row.failureReason:'成功' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="fetchData"	
        :current-page.sync ="page"
        layout="total,prev, pager, next, jumper"
        :page-size="pageSize"
        :total="total">
      </el-pagination>
  </div>
</el-dialog>
</template>
<script>
  export default {
    name:'popResultTable',
    data () {
      return {
        visibleDialog:false,
        tableData:[],
        popTitle:'',
        batchNo:'',
        loading:false,
        total:0,
        page:1,
        pageSize:10,
        type:'tag'
      }
    },
    
    methods: {
       // 批量设置不需要回显
      show(data) {
        this.popTitle = data.title
        this.batchNo = data.batchNo
        this.type = data.type || 'tag'
        this.tableData = []
        this.total = 0
        this.page = 1
        if (this.batchNo) {
          this.visibleDialog = true
          this.fetchData()
        }
        console.log('show:',data)
        
        
      },
      fetchData() {
        this.loading = true
        const params = { batchNo: this.batchNo, pageNo: this.page, pageSize: this.pageSize }
        let APIURL = 'omsOrderTagLog'
        if (this.type == 'publicAudit' || this.type == 'privateAudit') {
          APIURL = 'omsOrderAuditLog' // 公域审核 私域审核
        } else if (this.type == 'setOrderDate') {
          APIURL = 'omsSetDateLog' // 指定发货日期
        }else if (this.type == 'setLogistics') {
          APIURL = 'omsLogisticsLog' // 指定快递
        }
        this.$api[APIURL](params).then((res) => {
          if (res.code === 0) {
            this.tableData = res.data.list
            this.total = res.data.totalNum || res.data.total
          }
        }).finally(() => {
          this.loading = false
        })
      },
    },
  }
</script>
<style lang='scss'>
.pop-result-list{
  .result-con{
    padding: 10px 0 0 0;
    .el-table th.el-table__cell{
      padding: 0;
      height: 28px;
      line-height: 28px;
      font-weight: normal;
      background-color: #F8F8F8;
      .cell{
        font-size: 12px;
        font-weight: normal;
        padding-left: 12px;
        color: #7F7F7F;
      }
    }
    .el-table td.el-table__cell{
      padding: 0;
      padding: 6px 0 8px;
      .cell{
        font-size: 12px;
        padding-left: 12px;
        line-height: 18px;
      }
      .time{
        font-size: 12px;
        color: #7F7F7F;
      }
      .line{
        margin-bottom: 4px;
      }
      .tag-no{
        border: none;
        vertical-align: bottom;
        margin-right: -4px;
      }
    }
  }
  .el-pagination{
    text-align: right;
    padding: 20px 0;
  }
}
</style>